<template>
    <div class="login" id="login">
        <div class="container">
            <div class="logo">
                <img src="../../assets/images/login/logo.png" height="51">
                <h2>您好，欢迎来到CERM考试平台</h2>
            </div>
            <div class="loginBox" v-show="wjmm">
                <h2>找回密码</h2>
                <el-tabs v-model="zhActive" class="register">
                    <el-tab-pane name="tel">
                        <el-button slot="label" type="primary">手机号找回</el-button>
                        <el-form :model="zhTelInfo" :rules="zhTelRules" ref="zhTel" label-width="0" @submit.native.prevent>
                            <el-form-item prop="phone">
                                <el-input v-model="zhTelInfo.phone" placeholder="请输入注册时手机号"></el-input>
                            </el-form-item>
                            <el-form-item prop="code" class="code">
                                <el-input v-model="zhTelInfo.code" placeholder="请输入验证码"></el-input>
                                <send-code
                                    type="primary"
                                    v-model="sendCodeLoading3" 
                                    @click.native="sendCode3"
                                    init-str="获取验证码"
                                    storageKey="zhSendCode3"
                                    second="60"
                                ></send-code>
                            </el-form-item>
                            <el-form-item prop="newPwd">
                                <el-input v-model="zhTelInfo.newPwd" placeholder="请输入新密码"></el-input>
                            </el-form-item>
                            <el-form-item prop="newPwd1">
                                <el-input v-model="zhTelInfo.newPwd1" placeholder="请再输入一次"></el-input>
                            </el-form-item>
                            <el-button type="primary" :loading="zhLoading" @click="zhSubmit('zhTel')">提交</el-button>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane name="mail">
                        <el-button slot="label" type="primary">邮箱找回</el-button>
                        <el-form :model="zhMailInfo" :rules="zhMailRules" ref="zhMail" label-width="0" @submit.native.prevent>
                            <el-form-item prop="email">
                                <el-input v-model="zhMailInfo.email" placeholder="请输入注册时邮箱"></el-input>
                            </el-form-item>
                            <el-form-item prop="code" class="code">
                                <el-input v-model="zhMailInfo.code" placeholder="请输入验证码"></el-input>
                                <send-code
                                    type="primary"
                                    v-model="sendCodeLoading4"
                                    @click.native="sendCode4"
                                    init-str="邮箱验证码"
                                    storageKey="zhSendCode4"
                                    second="60"
                                ></send-code>
                            </el-form-item>
                            <el-form-item prop="newPwd">
                                <el-input v-model="zhMailInfo.newPwd" placeholder="请输入新密码"></el-input>
                            </el-form-item>
                            <el-form-item prop="newPwd1">
                                <el-input v-model="zhMailInfo.newPwd1" placeholder="请再输入一次"></el-input>
                            </el-form-item>
                            <el-button type="primary" :loading="zhLoading" @click="zhSubmit('zhMail')">提交</el-button>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="loginBox" v-show="!wjmm">
                <el-tabs v-model="activeLogin" @tab-click="handleClick">
                    <el-tab-pane label="登录" name="login">
                        <el-form :model="loginInfo" :rules="loginRules" ref="loginForm" label-width="0" @submit.native.prevent>
                            <el-form-item prop="username">
                                <el-input v-model="loginInfo.username" placeholder="请输入用户名/邮箱/手机号"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input type="password" v-model="loginInfo.password" placeholder="请输入密码" @keyup.native.enter="loginSubmit"></el-input>
                            </el-form-item>
                            <el-button type="primary" :loading="login_loading" @click="loginSubmit">登录</el-button>
                            <div class="remember">
                                <span @click="wjmm = true">忘记密码</span>
                                <el-checkbox v-model="remember">记住账号密码</el-checkbox>
                            </div>
                            <div class="weChat">
                                <h2><span>第三方账号登录</span></h2>
                                <ul>
                                    <li @click="wxLogin"><img src="../../assets/images/login/icon_we.png"></li>
                                </ul>
                            </div>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="注册" name="register" class="register">
                        <el-tabs v-model="activeRegister" @tab-click="handleClick">
                            <el-tab-pane name="tel">
                                <el-button slot="label" type="primary">手机号注册</el-button>
                                <el-form :model="registerTelInfo" :rules="registerTelRules" ref="registerTel" label-width="0" @submit.native.prevent>
                                    <el-form-item prop="chineseName">
                                        <el-input v-model="registerTelInfo.chineseName" placeholder="请输入真实姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="phone">
                                        <el-input v-model="registerTelInfo.phone" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="code" class="code">
                                        <el-input v-model="registerTelInfo.code" placeholder="请输入验证码"></el-input>
                                        <send-code
                                            type="primary"
                                            v-model="sendCodeLoading" 
                                            @click.native="sendCode"
                                            init-str="获取验证码"
                                            storageKey="registerSendCode"
                                            second="60"
                                        ></send-code>
                                    </el-form-item>
                                    <el-form-item prop="newPwd">
                                        <el-input v-model="registerTelInfo.newPwd" placeholder="请输入密码"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="documentType">
                                        <el-select clearable v-model="registerTelInfo.documentType" placeholder="请选择证件类型">
                                            <el-option clearable
                                                v-for="item in typeList"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item prop="documentNo">
                                        <el-input v-model="registerTelInfo.documentNo" placeholder="请输入证件号" @keyup.native.enter="registerSubmit('registerTel')"></el-input>
                                    </el-form-item>
                                    <el-button type="primary" :loading="registerLoading" @click="registerSubmit('registerTel')">注册</el-button>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane name="mail">
                                <el-button slot="label" type="primary">邮箱注册</el-button>
                                <el-form :model="registerMailInfo" :rules="registerMailRules" ref="registerMail" label-width="0" @submit.native.prevent>
                                    <el-form-item prop="chineseName">
                                        <el-input v-model="registerMailInfo.chineseName" placeholder="请输入真实姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="email">
                                        <el-input v-model="registerMailInfo.email" placeholder="请输入邮箱"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="code" class="code">
                                        <el-input v-model="registerMailInfo.code" placeholder="请输入验证码"></el-input>
                                        <send-code
                                            type="primary"
                                            v-model="sendCodeLoading1" 
                                            @click.native="sendCode1"
                                            init-str="邮箱验证码"
                                            storageKey="registerSendCode1"
                                            second="60"
                                        ></send-code>
                                    </el-form-item>
                                    <el-form-item prop="newPwd">
                                        <el-input v-model="registerMailInfo.newPwd" placeholder="请输入密码"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="documentType">
										<el-select clearable v-model="registerMailInfo.documentType" placeholder="请选择证件类型">
										    <el-option clearable
										        v-for="item in typeList"
										        :key="item.value"
										        :label="item.name"
										        :value="item.value">
										    </el-option>
										</el-select>
                                    </el-form-item>
                                    <el-form-item prop="documentNo">
                                        <el-input v-model="registerMailInfo.documentNo" placeholder="请输入证件号" @keyup.native.enter="registerSubmit('registerMail')"></el-input>
                                    </el-form-item>
                                    <el-button type="primary" :loading="registerLoading" @click="registerSubmit('registerMail')">注册</el-button>
                                </el-form>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div class="footerBottom">
            <my-footer />
        </div>
    </div>
</template>

<script>
import { getInfo, login, useradd, getCode, loginGetCode, wxCallLogin, wxCallHeartBeat, wxLoginMember, loginForget } from '@/api/user'
import { articleList } from '@/api/cms'
import { setToken } from '@/utils/auth'
import sendCode from '@/components/sendCode/sendCode'
import { listByType } from '@/api/cms'
import validTools from '@/utils/validTools'
export default {
    name: 'login',
    components: {
        sendCode
    },
    data(){
        let phoneRules =  (rule, value, callback) => {
            validTools('mobile', value, callback, '', false)
        }
        let mailRules =  (rule, value, callback) => {
            validTools('mail', value, callback, '', false)
        }
        let pwdRules =  (rule, value, callback) => {
            if(this.zhTelInfo.newPwd == value){
                return callback()
            }else{
                return callback(new Error('两次密码不一致'))
            }
        }

        let pwdRules1 =  (rule, value, callback) => {
            if(this.zhMailInfo.newPwd == value){
                return callback()
            }else{
                return callback(new Error('两次密码不一致'))
            }
        }
        
        return {
            login_loading: false,
            zhLoading: false,
            registerLoading: false,
            sendCodeLoading: false,
            sendCodeLoading1: false,
            sendCodeLoading3: false,
            sendCodeLoading4: false,
            wjmm: false,
            remember: localStorage.LOGIN_REMEMBER * 1 ? true : false,
            activeLogin: this.$route.query.type == 'register' ? 'register' : 'login',
            activeRegister: 'tel',
            exist: '',
            zhActive: 'tel',
            typeList: [],
            loginInfo: {
                username: localStorage.LOGIN_USER_NAME || '',
                password: localStorage.LOGIN_USER_PASSWORD || '',
            },
            zhTelInfo: {
                phone: '',
                code: '',
                newPwd: '',
                newPwd1: '',
            },
            zhMailInfo: {
                email: '',
                code: '',
                newPwd: '',
                newPwd1: '',
            },
            registerTelInfo: {
                chineseName: '',
				isChange: 1,
                phone: '',
                code: '',
                newPwd: '',
                documentType: '',
                documentNo: '',
            },
            registerMailInfo: {
                chineseName: '',
                isChange: 1,
                email: '',
                code: '',
                newPwd: '',
                documentType: '',
                documentNo: '',
            },
            loginRules: {
                username: [
                    { required: true, message: '请输入用户名/邮箱/手机号', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
            },
            zhTelRules: {
                phone: [
                    { required: true, message: '请输入手机号'},
                    { validator: phoneRules, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                newPwd1: [
                    { required: true, message: '请再次输入'},
                    { validator: pwdRules, trigger: 'blur' }
                ],
            },
            zhMailRules: {
                email: [
                    { required: true, message: '请输入邮箱'},
                    { validator: mailRules, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                newPwd1: [
                    { required: true, message: '请再次输入'},
                    { validator: pwdRules1, trigger: 'blur' }
                ],
            },
            registerTelRules: {
				chineseName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入手机号'},
                    { validator: phoneRules, trigger: 'blur' }
                ],
				code: [
				    { required: true, message: '请输入验证码', trigger: 'blur' },
				],
                documentType: [
                    { required: true, message: '请选择证件类型', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
				documentNo: [
				    { required: true, message: '请填写证件号码', trigger: 'blur' },
				]
            },
            registerMailRules: {
                chineseName: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱'},
                    { validator: mailRules, trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
                documentType: [
                    { required: true, message: '请选择证件类型', trigger: 'blur' },
                ],
                newPwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                ],
                documentNo: [
                    { required: true, message: '请填写证件号码', trigger: 'blur' },
                ]
            }
        }
    },
    mounted(){
        let state = this.$route.query.state
        let msg = this.$route.query.msg
        if(msg){
            this.$message.error(msg)
        }
		listByType("IDENTIFY").then(res => {
			this.typeList = res
		})
        if(state){
            wxCallHeartBeat({ type: 1, state }).then(res => {
                res.code = ''
                res.isChange = 1
                this.registerTelInfo = res
                this.registerMailInfo = res
                if(res.exist == 1){
                    this.wxLoginFunc('registerTelInfo')
                }else{
                    this.$message.info('请注册绑定账号')
                    this.exist = res.exist
                    this.activeLogin = 'register'
                }
            }).catch(error => {
                this.$message.error('微信登录超时，请重试')
                this.$router.replace('/login')
            })
        }
    },
    methods:{
        async login() {
            this.login_loading = true
            await this.$store.dispatch('login',this.loginInfo).then(()=>{
				if(this.remember){
				    localStorage.LOGIN_REMEMBER = 1
				    localStorage.LOGIN_USER_NAME = this.loginInfo.username
				    localStorage.LOGIN_USER_PASSWORD = this.loginInfo.password
				}else{
				    localStorage.LOGIN_REMEMBER = 0
				    localStorage.LOGIN_USER_NAME = ''
				    localStorage.LOGIN_USER_PASSWORD = ''
				}
				this.$router.replace(this.$store.state.routerTo)
				this.login_loading = false
			}).catch(()=>{
				this.login_loading = false
			})
        },
        async wxLoginFunc(name) {
            await this.$store.dispatch('wxLogin', this[name].openid).then(()=>{
                this.$router.replace(this.$store.state.routerTo)
            })
        },
        loginSubmit() {
            this.$refs['loginForm'].validate((valid) => {
                if (valid){
                    this.login()
                }
            })
        },
        zhSubmit(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid){
                    this.zhLoading = true
                    let name = ref == 'zhTel' ? 'zhTelInfo' : 'zhMailInfo'
					loginForget(this[name]).then(res=>{
                        if(res.code == 0){
                            this.activeLogin = "login"
                            this.wjmm = false
                        }
                        this.zhLoading = false
                    }).catch(res => {
                        this.zhLoading = false
                    })
                }
            })
        },
        registerSubmit(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid){
                    this.registerLoading = true
                    let name = ref == 'registerTel' ? 'registerTelInfo' : 'registerMailInfo'
                    useradd(this[name]).then(res=>{
                        if(res.code == 0){
                            this.activeLogin = "login"
                            if(this.exist == 1){
                                this.wxLoginFunc(name)
                            }
                        }
                        this.registerLoading = false
                    }).catch(res => {
                        this.registerLoading = false
                    })
                }
            })
        },
        sendCode() {
            this.$refs['registerTel'].validateField('phone', (valid) => {
                if (!valid){
                    this.sendCodeLoading = true
                    getCode({phone:this.registerTelInfo.phone}).then(res=>{
                    })
                }
            })
        },
        sendCode1() {
            this.$refs['registerMail'].validateField('email', (valid) => {
                if (!valid){
                    this.sendCodeLoading1 = true
                    getCode({email:this.registerMailInfo.email}).then(res=>{
                    })
                }
            })
        },
        sendCode3() {
            this.$refs['zhTel'].validateField('phone', (valid) => {
                if (!valid){
                    loginGetCode({phone:this.zhTelInfo.phone}).then(res=>{
						this.sendCodeLoading3 = true
                    })
                }
            })
        },
        sendCode4() {
            this.$refs['zhMail'].validateField('email', (valid) => {
                if (!valid){
                    loginGetCode({email:this.zhMailInfo.email}).then(res=>{
						this.sendCodeLoading4 = true
                    })
                }
            })
        },
        handleClick() {
			this.$refs['zhTel'].resetFields()
			this.$refs['zhMail'].resetFields()
			this.$refs['registerTel'].resetFields()
			this.$refs['registerMail'].resetFields()
        },
        wxLogin(){
            wxCallLogin({}).then(res => {
                if(res.loginUrl){
                    window.location.href = res.loginUrl
                }
            })
        }
    }
}
</script>

<style scoped>
    .login{min-height: 100vh;height: auto;background: url(../../assets/images/login/bg.jpg) center top;-webkit-background-size: 100% auto;background-size: 100% auto;position: relative;}
    .login>.container{height: 100%;z-index: 1;padding: 10% 0;overflow: hidden;}
    .loginBox{width: 450px;background: #fff;border-radius: 4px;float: right;}
    .loginBox{padding:0 44px;box-sizing:border-box;padding-top: 15px;padding-bottom: 38px;}
    .loginBox >>> .el-tabs__nav{width: 100%;}
    .loginBox >>> .el-tabs__item{width: 50%;margin: 0;text-align: center;height: 56px;line-height: 56px;font-size: 18px;color: #3d63a1;}
    .loginBox >>> .el-tabs__nav-wrap::after{background: #999999;height: 1px;}
    .loginBox >>> .el-tabs__active-bar{background: #3d63a1;height: 3px;}
    .loginBox >>> .el-tabs__header{margin-bottom: 40px;}
    .loginBox >>> .el-form-item{margin-bottom: 30px;}
    .loginBox >>> .el-input__inner{background: #f2f2f2;border:1px solid #e6e6e6;border-radius: 6px;}
    .loginBox >>> .el-input__inner:focus{border:1px solid #e6e6e6;}
    .loginBox >>> .el-form-item__error{padding-top: 8px;}
    .loginBox >>> .el-button{height: 40px; line-height: 40px; padding: 0; width: 100%;}
    .loginBox >>> .el-button span{font-size: 16px;}
    .loginBox >>> .el-button--primary{background: #3d63a1;border-color: #3d63a1;}
    .loginBox>h2{font-size: 18px;line-height: 56px;height: 55px;text-align: center;color: #3d63a1;border-bottom: 1px solid #999999;margin-bottom: 40px;}
    .remember{overflow: hidden;margin-top: 10px;margin-bottom: 40px;}
    .remember span{float: right;font-size: 12px;color: #000;text-decoration: underline;cursor: pointer;}
    .remember >>> .el-checkbox__label{font-size: 12px;color: #000;}
    
    .register >>> .el-tabs__item{height: 42px;line-height: 40px;}
    .register >>> .el-tabs__item .el-button--primary{background: #999;border-color: #999;}
    .register >>> .el-tabs__item.is-active .el-button--primary{background: #3d63a1;border-color: #3d63a1;}
    .register >>> .el-tabs__header{margin-bottom: 29px;}
    .register >>> .el-tabs__active-bar{display: none;}
    .register >>> .el-tabs__nav-wrap::after{display: none;}

    /*.registerTab{margin-bottom: 30px;}
    .registerTab >>> .el-button{width: 48%;}
    .registerTab >>> .el-button:last-child{margin-left: 4%;}*/

    .code >>> .el-input{width: 66%;}
    .code >>> .el-button{width: 30%;position: relative;top: 2px;margin-left: 4%;}
    .code >>> .el-button span{font-size: 14px;}

    .register >>> .el-select{width: 100%;}


    .footerBottom{position: absolute;bottom: 0;left: 0;width: 100%;font-size: 12px;color: #fff;padding: 14px 0;text-align: center;line-height: 24px;background: rgba(0,0,0,0.5);}

    .footerBottom >>> .footerTop{display: none;}
    .footerBottom >>> .container{border-top: 0;}
    .footerBottom >>> .container p{color: #fff;}

    .weChat{}
    .weChat h2{background: #999999;height: 1px;text-align: center;line-height: 0px;margin-bottom: 37px;}
    .weChat h2 span{font-size: 14px;color: #666666;background: #fff;padding: 0 10px;}
    .weChat ul{text-align: center;font-size: 0;line-height: 0;}
    .weChat li{display: inline-block;width: 44px;height: 44px;cursor: pointer;}
    .weChat li img{display: block;width: 44px;height: 44px;}

    .logo{float: left;padding-top: 110px;}
    .logo h2{margin-top: 40px;font-size: 36px;color: #fff;line-height: 36px;font-weight: 600;}


</style>
